import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { MessageBox } from "../utilityComponents";
import { UserService } from "../../services";
import { Button, ErrorFocus } from "../shared";

const NotSatisfiedModal = ({ show, closeModal, carDetails, getProgress, setLoader }) => {
  const { t } = useTranslation();
  const [messageBoxText, setMessageBoxText] = useState("");

  const validationSchema = () => {
    return Yup.object().shape({
      reason: Yup.string()
        .required(t("scheduleAppointment.required"))
        .max(500, t("scheduleAppointment.max500char"))
        .min(5, t("scheduleAppointment.min5char"))
    });
  };

  const handleSubmit = async (values) => {
    setLoader(true);
    try {
      const data = {
        ...values,
        phoneNumber: carDetails?.phoneNumber,
        make: carDetails?.make,
        model: carDetails?.model,
        carPlateNumber: carDetails?.carPlateNumber,
        branchCode: carDetails?.branchCode
      };
      const response = await UserService.customerFeedback(data);
      if (response) {
        await getProgress();
        closeModal();
      }
    } catch (e) {
      setMessageBoxText(e.response.data.message);
      console.error("Cancel Appointment api error :" + e);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Modal show={show} onHide={closeModal} centered={true}>
        <Modal.Body>
          <div className="cancel-appointment-modal">
            <h4>{t("track.reasonToNotSatisfied")}</h4>
            <Formik
              enableReinitialize
              initialValues={{
                reason: ""
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}>
              {({ errors, touched }) => (
                <div>
                  <Form>
                    <Field
                      as="textarea"
                      name="reason"
                      id="reason"
                      className="form-control"
                      placeholder={t("track.yourReasonHere")}
                    />
                    <div>
                      {errors.reason && touched.reason && (
                        <span className="red-color">{errors.reason}</span>
                      )}
                      <ErrorFocus />
                    </div>
                    <div className="controls">
                      <Button type="small-roundedLeft" customize="secondary" action={closeModal}>
                        {t("track.cancelClose")}
                      </Button>
                      <input
                        type="submit"
                        className="ah-btn primary-btn cancelBtn"
                        value={t("track.submit")}
                      />
                    </div>
                  </Form>
                </div>
              )}
            </Formik>
            <MessageBox type="error">{messageBoxText}</MessageBox>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default React.memo(NotSatisfiedModal);
